import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"
import { Pagination } from 'module-tsl-ui-pagination';
import WithDocgen from 'module-tsl-ui-pagination/with-docs/Pagination';
import pkg from 'module-tsl-ui-pagination/package.json';
import PropsTable from '../../../components/propsTable';
import Version from '../../../components/version';
import LiveCode from '../../../components/liveCode';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<MDXTag name="h3" components={components} props={{"id":"example-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#example-editable","aria-label":"example editable permalink","class":"anchor"}}></MDXTag>{`example (editable)`}</MDXTag>
<LiveCode
  code={`class Paginate extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentPage: 2, totalPages: 15 };
  }
  render() {
    return (
      <Pagination
        currentPage={this.state.currentPage}
        numberOfPages={this.state.totalPages}
        onChangePage={(p) => this.setState({ currentPage: p })}
      />
    )
  }
}`}
  scope={ { Pagination } }
/>
<PropsTable data={WithDocgen.__docgenInfo} />
<Version name={'npm i module-tsl-ui-pagination --save'} version={pkg.version} />
           </MDXTag>
  }
}

export const _frontmatter = {};

  